module.exports = __webpack_public_path__ + "media/images/supplementation_bg-5d5e397cbe4f23f9209d583fab98bc9c.png";